exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".role .custom-control-label{padding:0!important}", ""]);

// exports
